<template>
  <div>
    <Game--Stats :result="profit" :count-players="countPlayers" :delay="delay" />
    <GameStatisticsTable :items="statisticsRounds" :pullFunction="getRounds" />
    <Base--SideButtons :save="save" back />
  </div>
</template>

<script>
import GameStatisticsTable from './common/Table/GameStatisticsTable/GameStatisticsTable'
import {
  getDelay,
  getGeneralStatistics,
  getStatisticsRounds,
  updateDelay
} from '../../api/wheel'
import VueMixin from '../components/VueMixin'

export default {
  components: { GameStatisticsTable },
  mixins: [VueMixin],
  data () {
    return {
      profit: 0,
      countPlayers: 0,
      statisticsRounds: [],
      save: () => {
        if (this.delay >= 5000) this.AxiosHelperShowResponce(updateDelay(this.delay))
        else this.$store.dispatch('showErrorMessage', 'error. delay < 5000')
      }
    }
  },
  computed: {
    delay () {
      return this.$store.getters.delay
    }
  },
  mounted () {
    getDelay().then(response => {
      this.$store.commit('SET_DELAY', response.data.delay)
    })
    this.getRounds(1)
    getGeneralStatistics()
      .then()
      .then(response => {
        this.profit = response.data.profit
      })
  },
  methods: {
    getRounds (page) {
      getStatisticsRounds({ limit: 25, offset: (page - 1) * 25 }).then(response => {
        this.statisticsRounds = response.data
        if (this.statisticsRounds.length !== 0)
          this.countPlayers = this.statisticsRounds[0].count_player

      })
    }
  }
}
</script>
